import PropTypes from 'prop-types';
import { Box, Card, CardActionArea, CardContent, Typography } from '@mui/material';
import { AccountBalance as AccountBalanceIcon } from '@mui/icons-material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaypal } from '@fortawesome/free-brands-svg-icons';

// Card presentazionale di un singolo metodo di pagamento (PayPal / bonifico ...).
// Estratta a comportamento invariato dalla selezione metodo in RegistrationPage e ProfilePage.
// È "muta": non conosce lo stato: al click chiama onSelect(type) e lascia decidere al chiamante.
export default function PaymentMethodOption({ type, onSelect }) {
  return (
    <Card sx={{ display: 'flex' }}>
      <CardActionArea onClick={() => onSelect(type)}>
        <CardContent sx={{ flex: '1 0 auto' }}>
          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <Typography component="div" variant="h5">
              {type.name}
            </Typography>
            {type.type === 'PCC' ? (
              <FontAwesomeIcon icon={faPaypal} size="2x" color="#003087" />
            ) : (
              <AccountBalanceIcon sx={{ height: 32, width: 32, color: '#009CDE' }} />
            )}
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

PaymentMethodOption.propTypes = {
  type: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
};
